module.exports = __webpack_public_path__ + "asset/image-ic_category_22-b0816f74d12a2df5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_22.svg
// module id = Ub4b
// module chunks = 0